<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 500px">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S303忘記密碼</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td width="40%"><font color="#FF0000">*</font>帳號</td>
                <td width="60%">
                  <input type="text" v-model="form.Account" size="20" maxlength="20"/>
                </td>
              </tr>
              <tr>
                <td><font color="#FF0000">*</font>身分證統一編號</td>
                <td><input type="text" v-model="form.Idn" /></td>
              </tr>
              <tr>
                <td><font color="#FF0000">*</font>E-Mail</td>
                <td>
                  <input
                    type="text"
                    class="input"
                    title="所輸入EMAIL須與基本資料相同"
                    Placeholder="所輸入EMAIL須與基本資料相同"
                    size="40"
                    maxlength="40"
                    v-model="form.Email"
                  />
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <Captcha ref="Captcha" />
                  <a href="javascript:playmusic()">
                    <i style="font-size: 19px" class="fa fa-volume-up"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="確認"
                        @click="BtnConfirm()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="取消"
                        @click="BtnCancel()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
      </div>
    </div>

    <CyFooter />
    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import Captcha from "@/components/Common/Captcha.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { S303_Modify } from "@/service/api.js";
export default {
  name: "S303",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        PrgName: "S303",
        ServiceUnit: "CY",
        isForceLoginOut : false,
      },
      form: {
        Account: "",
        Idn: "",
        Email: "",
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    Captcha,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    BtnConfirm: function () {
      const self = this;
      let CaptchaComponent = self.$refs.Captcha;
      var errMsg = [];
      if (self.form.Account == "") {
        errMsg.push("請輸入帳號");
      }
      if (self.form.Idn == "") {
        errMsg.push("請輸入身分證統一編號");
      }
      if (self.form.Email == "") {
        errMsg.push("請輸入E-Mail");
      }
      if (CaptchaComponent.newRow.captcha === "") {
        errMsg.push("驗證碼不可為空");
      } else {
        if (CaptchaComponent.newRow.captcha != CaptchaComponent.captchaTxt) {
          errMsg.push("驗證碼不正確!");
        }
      }
      if (errMsg.length > 0) {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = errMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          self.Clear();
        };
        return;
      } else {
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          Account: self.form.Account,
          Idn: self.form.Idn,
          Email: self.form.Email,
          LogInfo:{
            Id:self.form.Account,
            PrgCode:"S303",
            ActCd:"確認",
            ServiceUnit:"PDIS",
            Token: "",
          }
        };
        S303_Modify(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              this.$router.push({ path: "/BackStage/CY/Login" });
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Clear();
              self.Alert.show = false;
            };
          }
        });
      }
    },
    BtnCancel: function () {
      const self = this;
      self.$router.push({ path: "/BackStage/CY/Login" });
    },
    Clear: function(){
      const self =this;
      self.$refs.Captcha.writeAuthCode();
      self.$refs.Captcha.newRow.captcha = "";
    }
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
